import { Col, List, Row } from 'antd';
import React, { FC, useContext } from 'react';
import { Query } from '@apollo/client/react/components';
import { ReferralData } from './GetReferralQuery';
import {
  ListAuditLogsQueryData,
  ListAuditLogsVariables,
  LIST_AUDIT_LOG_QUERY,
  AuditLogEntry,
  RecordContext,
} from './ListAuditLogQuery';
import { AppContext } from '../../../core/contexts/AppContext';
import _ from 'lodash';
import moment from 'moment';

type RecordContextDict = {
  response?: string;
  reason?: string;
  userName?: string;
};

const parseRecordContext = (recordContext: RecordContext[]): RecordContextDict => {
  return _.reduce(
    recordContext,
    (context: RecordContextDict, item: RecordContext) => {
      if (item.key === 'response') context.response = item.value;
      else if (item.key === 'reason') context.reason = item.value;
      else if (item.key === 'user_name') context.userName = item.value;
      return context;
    },
    {}
  );
};

const formatTimestamp = (insertedAt: string): string => {
  return moment
    .utc(insertedAt)
    .tz(moment.tz.guess())
    .format('MM/DD/YYYY @ h:mmA z');
};

const ReceiverResponseEntryItem: FC<{ entry: AuditLogEntry }> = ({ entry }): JSX.Element => {
  const context = parseRecordContext(entry.recordContext);
  const responseLabelMap: Record<string, string> = { accepted: 'Accepted', declined: 'Declined' };
  const responseLabel = (context.response && responseLabelMap[context.response]) || context.response || 'Unknown';
  const performedBy = context.userName || entry.user.name;

  return (
    <li className="mb-3">
      <p>
        On {formatTimestamp(entry.insertedAt)} the receiver response was set to <strong>{responseLabel}</strong>.
      </p>
      <p>Performed by {performedBy}</p>
      {context.reason && <p>Reason: {context.reason}</p>}
    </li>
  );
};

export const ReceiverResponseLogCard: FC<{ referral: ReferralData }> = ({ referral }): JSX.Element => {
  const { currentOrganization } = useContext(AppContext);

  return (
    <Query<ListAuditLogsQueryData, ListAuditLogsVariables>
      query={LIST_AUDIT_LOG_QUERY}
      variables={{
        action: 'referral.receiver_response',
        recordId: referral?.id,
        organizationId: currentOrganization?.id as string,
      }}
    >
      {({ loading, data }) => {
        if (loading || !data || !data.listAuditLogs) {
          return null;
        }
        return (
          <>
            <Row>
              <Col span={18}>
                <Row>
                  <Col span={24}>
                    <div>
                      <List
                        className="audit-log-list"
                        itemLayout="horizontal"
                        dataSource={data.listAuditLogs.entries}
                        renderItem={item => <ReceiverResponseEntryItem entry={item} />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={6}></Col>
            </Row>
          </>
        );
      }}
    </Query>
  );
};
